import { Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { ExpandableMinMaxFilterComponent, MinMaxFilterConfig } from "src/app/shared-components/expandable-min-max-filter/expandable-min-max-filter.component";
import { UnitAreaFilterModel } from "./search-filter-unitarea.model";

@Component({
    selector: "search-filter-unitarea",
    imports: [ExpandableMinMaxFilterComponent],
    templateUrl: "./search-filter-unitarea.component.html",
    styleUrl: "./search-filter-unitarea.component.scss",
})
export class SearchFilterUnitAreaComponent {
    filterForm = input.required<FieldTree<UnitAreaFilterModel>>();

    
    unitAreaTooltip = {
        show: false,
        header: "Areal",
        body: "Areal filtrer på BRA-i. Dersom BRA-i ikke er tilgjengelig benyttes P-ROM.",        
    };

    protected filterConfig = computed<MinMaxFilterConfig<UnitAreaFilterModel>>(() => ({
        filterForm: this.filterForm,
        title: "Areal",
        fromFieldAccessor: (form) => form.unitAreaFrom,
        toFieldAccessor: (form) => form.unitAreaTo,
        expandedAccessor: (form) => form.expanded,
        fromFieldId: "unitAreaFrom",
        toFieldId: "unitAreaTo",
        cssClass: "price",
        enableThousandize: true,
        tooltip: this.unitAreaTooltip
    }));
}
